//
//
//
//
//
//
//
//
//
//
//
//


export default ({
	data() {
		return {
			// Collapse navigation value.
			// Binded model property for "Collapsible Navigation Menu" collapsed status .
			collapseNav: 0,
		}
	},
})

